module.exports = __webpack_public_path__ + "img/1.be4d434.be4d434e.png";